import Swiper, { Navigation, Lazy } from 'swiper';

import '../../../node_modules/swiper/swiper.min.css';
import '../../../node_modules/swiper/modules/navigation/navigation.min.css';

Swiper.use([Navigation, Lazy])

export default (initialProductId = {}, initialFirstVariantId, initialSampleProductId) => ({
    productId: initialProductId,
    firstVariantId: initialFirstVariantId,
    sampleProductId: initialSampleProductId,

    init() {
        this.initSwiper()
    },

    eligibleForSample() {
        return this.sampleProductId && this.productId === this.firstVariantId
    },
    addToCart(quantity = 1) {
        let formData = {
            items: [{
                id: this.productId,
                quantity: quantity
            }]
        }

        if (this.eligibleForSample()) {
            const cartContainsSample = this.$store.cart.items.some(item => item.id === this.sampleProductId)

            if (!cartContainsSample) {
                formData.items.push({
                    id: this.sampleProductId,
                    quantity: 1,
                    properties: {
                        'paired_product_id': this.productId
                    }
                })

                formData.items.reverse()
            }
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.$store.cart.fetchCart()
            this.$store.cart.toggle()
        })
        .catch((error) => {
            console.error('Add to cart error:', error)
        })
    },
    updatePriceLabel(event) {
        try {
            const options = event.target.options
            const selectedOption = options[options.selectedIndex]
            const priceLabel = selectedOption.dataset.priceLabel
            this.$refs.price.innerText = priceLabel
        } catch(error) {
            console.error('Update price label error:', error)
        }
    },
    fetchActiveVideoElement(wrapper) {
        const videos = Array.from(wrapper.querySelectorAll('video'))
        return videos.find(video => getComputedStyle(video, null).display !== 'none')
    },
    initSwiper() {
        const swiper = new Swiper(this.$refs.productCarousel, {
            slidesPerView: 1,
            loop: true,
            preloadImages: false,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            keyboard: {
                enabled: true
            },
            navigation: {
                nextEl: '.product-carousel-next',
                prevEl: '.product-carousel-prev'
            }
        })
    },
    scrollToFooter() {
        const footer = document.getElementById('footer')
        window.scrollTo(0, document.body.scrollHeight - footer.offsetHeight);
    }
})
